/* eslint-disable */
import { useState, useCallback, useRef } from 'react';
import { notificationServices } from '@/Services';
import cookingRecipesServices from '@/Services/Form Services/cookingRecipes.services';

export const useRecipeData = (props) => {
	const { storeId } = props;
	const [rawData, setRawData] = useState({ columns: [], data: [] });
	const [isLoading, setIsLoading] = useState(false);
	const lastFetchParams = useRef({});

	// Transform API response to table format
	// Pivot data: FG names as columns, Ingredients as rows
	const transformRecipeData = useCallback((recipes) => {
		if (!recipes || !Array.isArray(recipes) || recipes.length === 0) {
			return { columns: [], data: [] };
		}

		// Collect all unique ingredients across all recipes
		const ingredientMap = new Map(); // key: ingredientProductId, value: ingredient info

		recipes.forEach((recipe) => {
			(recipe.ingredients || []).forEach((ingredient) => {
				const key = `${ingredient.productId}_${ingredient.variantId}`;
				if (!ingredientMap.has(key)) {
					ingredientMap.set(key, {
						productId: ingredient.productId,
						variantId: ingredient.variantId,
						productName: ingredient.productName || '-',
						variantName: ingredient.variantName || '-',
						variantItemCode: ingredient.variantItemCode || '-',
						unit: ingredient.unit || '-',
						skuType: ingredient.skuType || '-',
					});
				}
			});
		});

		// Define columns: First column is Ingredient info, then one column per FG
		const columns = [
			{
				key: 'ingredientName',
				label: 'Ingredient',
				dataType: 'string',
				searchable: true,
				fixed: true,
			},
			// { key: 'variantName', label: 'Variant', dataType: 'string' },
			{ key: 'variantItemCode', label: 'SKU Code', dataType: 'string' },
			{ key: 'unit', label: 'Unit', dataType: 'string' },
			// { key: 'skuType', label: 'SKU Type', dataType: 'string' },
		];

		// Add FG columns (one per recipe/product)
		recipes.forEach((recipe) => {
			const fgKey = `fg_${recipe.recipeId}_${recipe.variantId}`;
			columns.push({
				key: fgKey,
				label: recipe.productName + " (" + recipe.variantName + ")" || `FG ${recipe.recipeId}`,
				dataType: 'number',
				recipeId: recipe.recipeId,
				productId: recipe.productId,
				variantId: recipe.variantId,
			});
		});

		// Build a lookup for quick access: recipeId -> { ingredientKey -> qty }
		const recipeIngredientQty = new Map();
		recipes.forEach((recipe) => {
			const ingredientQtyMap = new Map();
			(recipe.ingredients || []).forEach((ingredient) => {
				const key = `${ingredient.productId}_${ingredient.variantId}`;
				if(ingredient.variantId===1){
					console.log(key,ingredient.qty,'pppppppppppppkey');
				}
				ingredientQtyMap.set(key, ingredient.qty);
			});
			recipeIngredientQty.set(recipe.variantId, ingredientQtyMap);
		});

		// Transform data rows: one row per unique ingredient
		const data = [];
		ingredientMap.forEach((ingredientInfo, ingredientKey) => {
			const row = {
				ingredientKey,
				productId: ingredientInfo.productId,
				variantId: ingredientInfo.variantId,
				ingredientName:
					ingredientInfo.productName +
					'(' +
					ingredientInfo.variantName +
					')',
				variantName: ingredientInfo.variantName,
				variantItemCode: ingredientInfo.variantItemCode,
				unit: ingredientInfo.unit?.toLowerCase() === 'count'
						? 'pcs'
						: 
					ingredientInfo.unit?.toLowerCase() === 'gram'
						? 'gm'
						: ingredientInfo.unit,
				skuType: ingredientInfo.skuType,
			};

			// Add quantity for each FG column
			recipes.forEach((recipe) => {
				const fgKey = `fg_${recipe.recipeId}_${recipe.variantId}`;
				const ingredientQtyMap = recipeIngredientQty.get(
					recipe.variantId
				);
				const qty = ingredientQtyMap?.get(ingredientKey);
				const unitSuffix =
					ingredientInfo.unit?.toLowerCase() === 'count'
						? 'pcs'
						: 
					ingredientInfo.unit?.toLowerCase() === 'gram'
						? 'gm'
						: ingredientInfo.unit;
				row[fgKey] = qty != null ? `${qty} ${unitSuffix}` : '-';
			});

			data.push(row);
		});

		return { columns, data };
	}, []);

	const fetchData = useCallback(
		async (filter, refresh = false) => {
			if (!filter?.storeId && !storeId) {
				console.log('Store ID is required');
				return;
			}

			if (!refresh) {
				lastFetchParams.current.fetchData = { filter };
			}

			setIsLoading(true);

			try {
				const response =
					await cookingRecipesServices.fetchRecipesByStore({
						req: {
							data: {
								storeId: filter?.storeId || storeId,
							},
						},
					});

				if (
					response?.statusCode === 200 ||
					response?.status === 'Success'
				) {
					const recipes = (response?.data || []).slice(0, 20); // Limit to 50 recipes
					const transformedData = transformRecipeData(recipes);
					setRawData(transformedData);
					// setRawData({ columns: [], data: [] });
				} else {
					notificationServices?.generateNotification({
						type: 'error',
						message: response?.message || 'Failed to fetch recipes',
					});
					setRawData({ columns: [], data: [] });
				}
			} catch (error) {
				notificationServices?.generateNotification({
					type: 'error',
					message: error.message || 'Failed to fetch recipes',
				});
				setRawData({ columns: [], data: [] });
			} finally {
				setIsLoading(false);
			}
		},
		[storeId, transformRecipeData]
	);

	const refresh = useCallback(async () => {
		if (lastFetchParams.current.fetchData) {
			const { filter } = lastFetchParams.current.fetchData;
			fetchData(filter, true);
		}
	}, [fetchData]);

	return {
		rawData,
		isLoading,
		fetchData,
		refresh,
	};
};
